import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionIcon,
  AccordionItem,
  AccordionTrigger,
} from "ui/gluestack/accordion";
import {
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  EditIcon,
  Icon,
} from "ui/gluestack/icon";
import { View } from "ui/atoms/view";
import { Pressable, Text, TextInput } from "react-native";
import { useEffect, useState } from "react";

interface Props {
  children: React.ReactNode;
  titleValue: string;
  onChangeTitle: (value: string) => void;
  isEditing?: boolean;
  canEditTitle?: boolean;
}

export function CurrentShiftAccordion({
  children,
  titleValue,
  onChangeTitle,
  isEditing = true,
  canEditTitle = true,
}: Props) {
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [currentTitle, setCurrentTitle] = useState(titleValue);
  const [expanded, setExpanded] = useState("new");

  useEffect(() => {
    if (!currentTitle) {
      const currentHour = new Date().getHours();

      const automaticTitle =
        currentHour >= 12 && currentHour < 24
          ? "Evening Handover"
          : "Morning Handover";
      setCurrentTitle(automaticTitle);
      onChangeTitle(automaticTitle);
    }
  }, []);

  const handleSaveTitle = () => {
    setIsEditingTitle(false);
    onChangeTitle(currentTitle.trim());
  };
  const renderTitle = () => {
    if (isEditing && canEditTitle) {
      if (isEditingTitle) {
        return (
          <View className="flex flex-row items-center gap-x-2">
            <TextInput
              value={currentTitle}
              onChangeText={setCurrentTitle}
              className="text-gray-700 font-semibold text-lg border-b border-gray-300 flex-1"
              placeholder="Enter title"
              onBlur={handleSaveTitle}
            />
            <Pressable onPress={handleSaveTitle}>
              <Icon as={CheckIcon} className="h-5 w-5 text-primary-500" />
            </Pressable>
          </View>
        );
      } else {
        return (
          <Pressable
            className="flex flex-row items-center gap-x-2 group"
            onPress={() => setIsEditingTitle(true)}
          >
            <Text className="text-gray-700 font-semibold text-lg group-hover:text-primary-400">
              {currentTitle || "Enter title"}
            </Text>
            <Icon
              as={EditIcon}
              className="h-4 w-4 group-hover:stroke-primary-400"
            />
          </Pressable>
        );
      }
    } else {
      return (
        <View className="flex flex-row justify-between items-center">
          <Text className="text-gray-700 font-semibold text-lg">
            {currentTitle}
          </Text>
        </View>
      );
    }
  };

  return (
    <Accordion
      type="single"
      variant="filled"
      className="w-full"
      value={expanded}
      onValueChange={(value) => setExpanded(value || "new")}
    >
      <AccordionItem
        key="new"
        value="new"
        className="border rounded-lg border-border-200 p-2 bg-white"
      >
        <AccordionHeader>
          <AccordionTrigger className="focus:web:rounded-lg">
            {({ isExpanded }) => (
              <>
                <View className="items-start gap-2">{renderTitle()}</View>
                {isExpanded ? (
                  <AccordionIcon as={ChevronUpIcon} />
                ) : (
                  <AccordionIcon as={ChevronDownIcon} />
                )}
              </>
            )}
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent>{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
